export const CONSTANT = 'constant';
export const DECREASING = 'decreasing';

export const CONSTANT_FEE = 'constantFee';
export const CHANGING_FEE = 'changingFee';
